module.exports = __webpack_public_path__ + "img/lab-1-text-eng.8bf5b706.svg";